/*
	PubExchange Widget.Only enabled as of now for ARCH, EBB and PORT
*/
const PubExchangeWidget = (props) => {
  const widgetId = props.pubexchangeSetting
    ? props.pubexchangeSetting.widget_id
    : "";
  // publication = props.pubexchangeSetting ? props.pubexchangeSetting.publication : "",
  // moduleId = props.pubexchangeSetting ? props.pubexchangeSetting["module-num"] : "";
  return (
    <div
      className="pubexchange_module"
      id="pubexchange_below_content"
      data-pubexchange-module-id={widgetId}
    ></div>
  );
};

export default PubExchangeWidget;
